/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import CardMessageNoAvatar from 'DesignSystem/CardMessageNoAvatar/index'
import DateTime from './DateTime/index'
import React from 'react'
import StatusName from './StatusName/index'
import UserName from './UserName/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Status/Content/Content"
  
}) {
  return (<React.Fragment
>
<CardMessageNoAvatar
  viewPath={`${viewPath}/CardMessageNoAvatar`}
 marginTop={16}
 marginBottom={8}
 marginLeft={30}
 alignSelf="flex-end"
 maxWidth={600}
 backgroundColor="rgba(0,0,0,0.02)"
>
{childProps => (
<React.Fragment>
<StatusName
{...childProps}
  viewPath={`${viewPath}/StatusName`}
/>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<UserName
  viewPath={`${viewPath}/UserName`}
/>
<DateTime
  viewPath={`${viewPath}/DateTime`}
/>
</div>
</React.Fragment>
)}
</CardMessageNoAvatar>
{children}
</React.Fragment>)
}